export var DisplayState;

(function (DisplayState) {
  DisplayState["FORM"] = "contactAgentForm";
  DisplayState["ABAD_CONTENT"] = "abadContent";
  DisplayState["SUCCESS"] = "submitSuccess";
})(DisplayState || (DisplayState = {}));
//# sourceMappingURL=index.js.map